'use client';

import {CircularProgress} from '@pixel-party/CircularProgress/v2';
import {useTranslation} from 'react-i18next';
import {FormError} from '@/components';

interface SubmitButtonProps {
  isDisabled: boolean;
  isPending: boolean;
  label?: string;
  rootError?: string;
}

export function SubmitButton({
  isDisabled,
  isPending,
  label,
  rootError,
}: SubmitButtonProps) {
  const {t} = useTranslation();

  return (
    <div className="action">
      <button
        className="submit"
        disabled={isDisabled}
        type="submit"
      >
        {label || t('buttons.submit')}
        {isPending && (
          <CircularProgress
            size="xsmall"
            color="white"
          />
        )}
      </button>
      {!isPending && rootError && <FormError message={rootError} />}
    </div>
  );
}
